module.exports = __webpack_public_path__ + "static/media/icon-services-bin.f01be5ae.png";